import { c as _c } from "react/compiler-runtime";
import { RequestsLayout } from '@src/components/sco/Requests/Layout/RequestsLayout';
import { RequestBrowse } from '@src/components/sco/Requests/RequestBrowse';
import { useParams } from 'next/navigation';
export default function Page() {
  const $ = _c(5);
  const params = useParams();
  let t0;
  if ($[0] !== params.groupRequestId) {
    t0 = params.groupRequestId?.toString();
    $[0] = params.groupRequestId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RequestBrowse />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <RequestsLayout groupRequestId={t0} mainPanel={t1} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}